/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { Breadcrumb } from '@zeeve-platform/breadcrumb-component';
import { Modal } from '@zeeve-platform/modal-component';
import Urls from '../../utils/urls';
import CustomLoader from '../common/loader';
import apiBackendInstance from '../../utils/axios';
import { prefixPath } from '../../utils/helpers';
import Styles from './PIPBody.module.css';

// PurchaseIndexingProtocol Body
const PIPBody = () => {
  localStorage.setItem('market_place_source', 'subgraph');
  const [status, setStatus] = useState(false);
  const [redirectionLink, setRedirectionLink] = useState('#');
  const [btnDisable, setBtnDisable] = useState(false);
  const [apiResponse, setApiResponse] = useState('');
  const [showLoader, setShowLoader] = useState(true);
  const [dataLoaded, setDataLoaded] = useState<boolean>(false);
  const [prices, setPrices] = useState<number[]>([0.00, 0.00]);
  const [subgraphQuantity, setSubgraphQuantity] = useState<number>(0);
  const [addonQuantity, setAddonQuantity] = useState<number>(0);
  const [showModal, setShowModal] = useState(false);

  const paths = [{ name: 'Dashboard', path: prefixPath('/dashboard') }];
  const getPlanDetails = () => {
    setShowLoader(true);
    apiBackendInstance
      .get(Urls.getPlans('subgraph'), {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        if (response.data.success) {
          const planPrices = prices;
          const subgraphIndexingPlan = response.data.data.filter((item: any) => item.code === Urls.getItemCode('SUBGRAPHINDEXING'));
          if (subgraphIndexingPlan.length) {
            planPrices[0] = subgraphIndexingPlan[0].price;
          }
          const queryAddonPlan = response.data.data.filter((item: any) => item.code === Urls.getItemCode('SUBGRAPHQUERYADDON'));
          if (queryAddonPlan.length) {
            planPrices[1] = queryAddonPlan[0].price;
          }
          setPrices(planPrices);
          setDataLoaded(true);
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        setDataLoaded(false);
        console.error(err);
      });
  };

  useEffect(() => {
    if (!dataLoaded) getPlanDetails();
  }, []);

  const increaseSubgraphQty = () => {
    setSubgraphQuantity(subgraphQuantity + 1);
  };

  const decreaseSubgraphQty = () => {
    if (subgraphQuantity > 0) {
      setSubgraphQuantity(subgraphQuantity - 1);
    }
  };

  const increaseAddonQty = () => {
    setAddonQuantity(addonQuantity + 1);
  };

  const decreaseAddonQty = () => {
    if (addonQuantity > 0) {
      setAddonQuantity(addonQuantity - 1);
    }
  };

  const buyNow = () => {
    setShowLoader(true);
    const addons = [];
    if (subgraphQuantity > 0) {
      addons.push({ code: Urls.getItemCode('SUBGRAPHINDEXING'), quantity: subgraphQuantity });
    }
    if (addonQuantity > 0) {
      addons.push({ code: Urls.getItemCode('SUBGRAPHQUERYADDON'), quantity: addonQuantity });
    }
    const payload = {
      plan: { code: Urls.getItemCode('BASEPLANCODE'), quantity: 1 },
      addOns: addons,
      serviceType: 'subgraph',
    };
    apiBackendInstance
      .post(
        Urls.getSubscription(),
        { ...payload },
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      )
      .then((response) => {
        if (response?.data?.data?.message) {
          setApiResponse(response.data.data.message);
        }
        if (response.data.success) {
          if (response?.data?.data?.redirectionUrl) {
            setStatus(true);
            setRedirectionLink(response.data.data.redirectionUrl);
          }
          setShowModal(true);
        }
        setBtnDisable(false);
        setShowLoader(false);
      })
      .catch((err) => {
        const errMsgRes = err && err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : 'Request Failed';
        setApiResponse(`Error: ${errMsgRes}`);
        setShowModal(true);
        setStatus(false);
        setRedirectionLink('');
        setBtnDisable(false);
        setShowLoader(false);
      });
  };

  return (
    <section className="px-5 col-12 workspace">
      <div className="col-11 mx-auto">
        <div className="row">
          <div className="">
            <Breadcrumb
              prefixLink={paths}
              activeLink="Subgraph"
            />
          </div>
        </div>
        <div className="row justify-content-between">
          <CustomLoader showLoader={showLoader} />
          <div className={Styles.PIPContainer}>
            <div className={Styles.Heading}>
              <span className={Styles.HeadingText}>Purchase Subgraph</span>
            </div>
            <div className={Styles.CartLayout}>
              <div className={Styles.CartRow}>
                <div className={Styles.RowItem}>
                  <div className={Styles.RowItemText}>Service</div>
                </div>
                <div className={Styles.RowItem}>
                  <div className={Styles.RowItemText}>Description</div>
                </div>
                <div className={Styles.RowItem}>
                  <div className={Styles.RowItemText}>Unit Price</div>
                </div>
                <div className={Styles.RowItem} style={{ flexDirection: 'row' }}>
                  <div className={Styles.RowItemText}>Quantity</div>
                </div>
                <div className={Styles.RowItem} style={{ textAlign: 'end' }}>
                  <div className={Styles.RowItemText}>Sub-Total</div>
                </div>
              </div>
              <div className={`${Styles.CartRow} ${Styles.DataRow}`}>
                <div className={Styles.RowItem}>
                  <div className={Styles.DataRowValue}>Subgraph</div>
                </div>
                <div className={Styles.RowItem}>
                  <div className={Styles.DataRowValue}>
                      10,000,000 API Units / month
                      <br />
                      15 Queries / second
                  </div>
                </div>
                <div className={Styles.RowItem}>
                  <div className={Styles.DataRowValue}>{`$${prices[0]}`}</div>
                </div>
                <div className={Styles.RowItem} style={{ flexDirection: 'row' }}>
                  <div className={Styles.QuantityInnerLayout}>
                    <div className={Styles.ChangeQuantity} style={{ cursor: 'pointer' }} role="presentation" onClick={decreaseSubgraphQty}>
                      <div className={Styles.QuantityText}>-</div>
                    </div>
                    <div className={Styles.ChangeQuantity} style={{ background: 'white' }}>
                      <div className={Styles.QuantityText}>{subgraphQuantity}</div>
                    </div>
                    <div className={Styles.ChangeQuantity} style={{ cursor: 'pointer' }} role="presentation" onClick={increaseSubgraphQty}>
                      <div className={Styles.QuantityText}>+</div>
                    </div>
                  </div>
                </div>
                <div className={Styles.RowItem} style={{ alignItems: 'flex-end' }}>
                  <div className={Styles.DataRowValue} style={{ alignItems: 'flex-end' }}>{`$${prices[0] * subgraphQuantity}`}</div>
                </div>
              </div>
              <div className={`${Styles.CartRow} ${Styles.DataRow}`}>
                <div className={Styles.RowItem}>
                  <div className={Styles.DataRowValue}>Addon</div>
                </div>
                <div className={Styles.RowItem}>
                  <div className={Styles.DataRowValue}>
                    1,000,000 API Units/month
                    <br />
                    15 Queries/second
                  </div>
                </div>
                <div className={Styles.RowItem}>
                  <div className={Styles.DataRowValue}>{`$${prices[1]}`}</div>
                </div>
                <div className={Styles.RowItem} style={{ flexDirection: 'row' }}>
                  <div className={Styles.QuantityInnerLayout}>
                    <div className={Styles.ChangeQuantity} style={{ cursor: 'pointer' }} role="presentation" onClick={decreaseAddonQty}>
                      <div className={Styles.QuantityText}>-</div>
                    </div>
                    <div className={Styles.ChangeQuantity} style={{ background: 'white' }}>
                      <div className={Styles.QuantityText}>{addonQuantity}</div>
                    </div>
                    <div className={Styles.ChangeQuantity} style={{ cursor: 'pointer' }} role="presentation" onClick={increaseAddonQty}>
                      <div className={Styles.QuantityText}>+</div>
                    </div>
                  </div>
                </div>
                <div className={Styles.RowItem} style={{ alignItems: 'flex-end' }}>
                  <div className={Styles.DataRowValue} style={{ alignItems: 'flex-end' }}>{`$${prices[1] * addonQuantity}`}</div>
                </div>
              </div>
            </div>
            <div className={Styles.CartTotalRow}>
              <div className={Styles.CartTotalLabelBox}>
                <div className={Styles.CartTotalLabel}>Total</div>
              </div>
              <div className={Styles.CartAmountBox}>
                <div className={Styles.CartTotalLabel} style={{ textAlign: 'right' }}>{`$${(prices[1] * addonQuantity) + (prices[0] * subgraphQuantity)}`}</div>
              </div>
            </div>
            <div className={Styles.Footer}>
              <button type="button" className={Styles.FTBtnLayout} onClick={buyNow} disabled={((prices[1] * addonQuantity) + (prices[0] * subgraphQuantity)) <= 0}>
                <div className={Styles.BtnText}>Buy Now</div>
              </button>
            </div>
          </div>
        </div>
        <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        title="Purchasing Subgraph"
        confirmBtnText="Continue"
        visibleFooterCloseButton
        visibleFooter
        visibleConfirmBtn={status}
        visibleHeaderCloseIcon={false}
        disableConfirmBtn={btnDisable}
        onConfirm={() => window.open(redirectionLink, '_self')}
        >
        <p className="status text-center mt-3" id="modal_status">
          {apiResponse}
        </p>
        </Modal>
      </div>
    </section>
  );
};

export default PIPBody;
